// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  cursor: pointer;
}

h1.page-header {
  color: #7f47d1;
}

#swipe-area {
  position: fixed;
  height: 100vh;
  width: 15px;
  z-index: 2;
}

.breadcrumb {
  margin: 30px 40px 10px;
  padding: 0;
}

.page-title {
  font-size: 23px;
  width: 100%;
  display: inline-block;
  color: #8e42ff;
  font-weight: 600;
}

.page-path {
  color: #999999;
  font-size: 11px;
  margin-left: 2px;
}

#content-container {
  padding-left: 220px;
  left: 0 !important;
}

@media only screen and (max-width: 769px) {
  #content-container {
    padding-left: 0px;
    left: 0 !important;
  }
}
@media only screen and (min-width: 768px) {
  #content-container {
    padding-left: 220px;
    left: 0 !important;
  }
}
.modal-header {
  padding: 15px;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
}
.modal-header:after {
  content: normal;
}
.modal-header h2 {
  font-weight: 100;
  text-align: center;
}

.modal-body > p {
  text-align: center;
  margin-bottom: 30px;
}

.btns .btn-next button {
  left: 50%;
  position: relative;
  transform: translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/dashboard.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,eAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AADJ;;AAIA;EACC,sBAAA;EACA,UAAA;AADD;;AAIA;EACC,eAAA;EACG,WAAA;EACA,qBAAA;EACA,cCfO;EDgBP,gBAAA;AADJ;;AAIA;EACC,cCbW;EDcX,eAAA;EACA,gBAAA;AADD;;AAIA;EACI,mBAAA;EACA,kBAAA;AADJ;;AAIA;EACI;IACI,iBAAA;IACA,kBAAA;EADN;AACF;AAIA;EACI;IACI,mBAAA;IACA,kBAAA;EAFN;AACF;AAKA;EACE,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAHF;AAIE;EACI,eAAA;AAFN;AAIE;EACI,gBAAA;EACA,kBAAA;AAFN;;AAOE;EACE,kBAAA;EACA,mBAAA;AAJJ;;AAUI;EACE,SAAA;EACA,kBAAA;EACA,2BAAA;AAPN","sourcesContent":["@import '../../../sass/variables';\n\na {\n    cursor: pointer;\n}\n\nh1.page-header {\n    color: #7f47d1;\n}\n\n#swipe-area {\n    position: fixed;\n    height: 100vh;\n    width: 15px;\n    z-index: 2;\n}\n\n.breadcrumb {\n\tmargin: 30px 40px 10px;\n\tpadding: 0;\n}\n\n.page-title {\n\tfont-size: 23px;\n    width: 100%;\n    display: inline-block;\n    color: $roxo-500;\n    font-weight: 600;\n}\n\n.page-path {\n\tcolor: $cinza-500;\n\tfont-size: 11px;\n\tmargin-left: 2px; // alinhamento visual em relação ao título\n}\n\n#content-container {\n    padding-left: 220px;\n    left: 0 !important;\n}\n\n@media only screen and (max-width: 769px) {\n    #content-container {\n        padding-left: 0px;\n        left: 0 !important;\n    }\n}\n\n@media only screen and (min-width: 768px) {\n    #content-container {\n        padding-left: 220px;\n        left: 0 !important;\n    }\n}\n\n.modal-header {\n  padding: 15px;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 90px;\n  &:after {\n      content: normal;\n  }\n  h2 {\n      font-weight: 100;\n      text-align: center;\n  }\n}\n\n.modal-body {\n  > p {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n}\n\n.btns {\n  .btn-next {\n    button {\n      left: 50%;\n      position: relative;\n      transform: translateX(-50%);\n    }\n  }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
